import { DatePickerView } from '@mui/lab/DatePicker/shared';
import {
  DocumentMarriageFilterFormCertification,
  DocumentMarriageVM,
} from 'civil-status/view-models/document-marriage-list';
import { DateTime } from 'luxon';
import { ForeignStateVM } from 'shell/components/shared/foreign-state-list';
import { MunicipalityAnprVM } from 'shell/components/shared/municipality-list';
import { BaseTableRows } from 'shell/components/shared/table/types';
import { SubjectData } from 'shell/models/person';
import { ItemVM } from 'shell/view-models/item';

export type ListTableItemVM = ItemVM & BaseTableRows & { position?: number; action?: string };
export interface CommonCivilStatusFormVM {
  year?: string;
  registerNumber?: string;
  documentNumber?: string;
  portion?: string;
  serie?: string;
  serie2?: string;
  annotationNational?: string;
  noteNational?: string;
  annotationInternational?: string;
  noteInternational?: string;
  uploadFile?: { file?: File; raw: Array<string>; rawTiff: string };
  annotationNationalList?: Array<ListTableItemVM>;
  annotationInternationalList?: Array<ListTableItemVM>;
  indicatorUpdate?: string;
}
export interface DocumentBirthFormVM extends CommonCivilStatusFormVM {
  matricola?: string;
  surname?: string;
  name?: string;
  gender?: string;
  municipalityBirth?: string;
  surnameFather?: string;
  nameFather?: string;
  surnameMother?: string;
  nameMother?: string;
  time?: DateTime | null;
  birthday?: DateTime | null;
}
export enum CertificateType {
  nascita = '0',
  matrimonio = '1',
  morte = '2',
  unioneCivile = '3',
  cittadinanza = '4',
}
export interface CertificateValue {
  copia?: string;
  certificato?: string;
  estratto?: string;
  estrattoVienna?: string;
  estrattoParigi?: string;
}
export const CertificateValueBorn: CertificateValue = {
  copia: '01',
  certificato: '02',
  estratto: '03',
  estrattoVienna: '04',
  estrattoParigi: '05',
};
export const CertificateValueMarriage: CertificateValue = {
  copia: '11',
  certificato: '12',
  estratto: '13',
  estrattoVienna: '14',
  estrattoParigi: '15',
};
export const CertificateValueDeath: CertificateValue = {
  copia: '21',
  certificato: '22',
  estratto: '23',
  estrattoVienna: '24',
  estrattoParigi: '25',
};
export const CertificateValueCivilUnion: CertificateValue = {
  copia: '31',
  certificato: '32',
  estratto: '33',
};
export const CertificateValueCitizenship: CertificateValue = {
  copia: '41',
};
export type CertificateRadio = {
  type?: CertificateType;
  value?: string;
};
export interface CertificationFormVM {
  datiSoggetto?: SubjectData;
  reasonRelease?: string;
  fiscalCode?: string;
  searchApplicant?: boolean;
  matricola?: string;
  surname?: string;
  withoutSurname?: boolean;
  name?: string;
  withoutName?: boolean;
  gender?: string;
  birthDate?: DateTime | null;
  birthChoiceDate?: Array<DatePickerView>;
  municipality?: MunicipalityAnprVM | null;
  municipalityDocument?: MunicipalityAnprVM | null;
  isForeign?: boolean;
  foreignState?: ForeignStateVM | null;
  foreignMunicipality: MunicipalityAnprVM | null;
  foreignStateDocument?: string;
  documentNumber?: string;
  documentIssuedDate?: DateTime | null;
  isForeignDocument?: boolean;
  certificate?: CertificateRadio | null;
  documentSearch?: DocumentMarriageFilterFormCertification | null;
  chosenDocument?: DocumentMarriageVM | null;
  documentChosenBirth?: DocumentBirthFormVM | null;
  documentChosenDeath?: DocumentDeathFormVM | null;
  documentChosenMarriage?: DocumentMarriageFormVM | null;
  documentChosenCivilUnion?: DocumentCivilUnionFormVM | null;
  documentChosenCitizenship?: DocumentCitizenshipFormVM | null;
  file?: File;
  raw?: Array<string>;
  rawTiff?: string;
  timber?: string;
  timberFreeText?: string;
  modifierCode?: string;
  copies: string;
  flagCarta?: boolean;
  flagInternal?: boolean;
  flagSign?: boolean;
  flagOmittedSign?: boolean;
  flagFincatura?: boolean;
  birthplace?: string;
  residenceString?: string;
  state?: string;
  idSubjectAnpr?: string;
  reason?: string;
  selectedCertificate?: string;
  typePayment?: string;
}
export interface DocumentMarriageFormVM extends CommonCivilStatusFormVM {
  marriageDate?: DateTime | null;
  marriageMunicipality?: string;
  matricolaHusband?: string;
  surnameHusband?: string;
  nameHusband?: string;
  genderHusband?: string;
  birthdayHusband?: DateTime | null;
  citizenshipWife?: string;
  citizenshipHusband?: string;
  yearsHusband?: string;
  yearDateHusband?: string;
  municipalityBirthHusband?: string;
  residenceMunicipalityHusband?: string;
  statusHusband?: string;
  surnameAfterMarriageHusband?: string;
  matricolaWife?: string;
  surnameWife?: string;
  nameWife?: string;
  genderWife?: string;
  birthdayWife?: DateTime | null;
  yearsWife?: string;
  yearDateWife?: string;
  municipalityBirthWife?: string;
  residenceMunicipalityWife?: string;
  statusWife?: string;
  surnameAfterMarriageWife?: string;
}
export interface DocumentDeathFormVM extends CommonCivilStatusFormVM {
  matricola?: string;
  surname?: string;
  name?: string;
  gender?: string;
  deathPresumed?: boolean;
  hourDeathUnknown?: boolean;
  years?: string;
  yearDate?: string;
  deathDate?: DateTime | null;
  hourDeathDate?: DateTime | null;
  deathBy?: DateTime | null;
  deathTo?: DateTime | null;
  deathMunicipality?: string;
  residenceMunicipality?: string;
  birthday?: DateTime | null;
  municipalityBirth?: string;
  status?: string;
  // surnameFather?: string;
  // nameFather?: string;
  // surnameMother?: string;
  // nameMother?: string;
  spouseSurname?: string;
  spouseName?: string;
}
export interface DocumentCivilUnionFormVM extends CommonCivilStatusFormVM {
  matricola?: string;
  matricola2?: string;
  surname?: string;
  surname2?: string;
  name?: string;
  yearsDeclarant1?: string;
  yearDateDeclarant1?: string;
  yearDateDeclarant2?: string;
  yearsDeclarant2?: string;
  name2?: string;
  gender?: string;
  gender2?: string;
  municipalityBirth?: string;
  municipalityBirth2?: string;
  time?: DateTime | null;
  time2?: DateTime | null;
  birthday?: DateTime | null;
  birthday2?: DateTime | null;
  nameFather?: string;
  nameFather2?: string;
  surnameFather?: string;
  surnameFather2?: string;
  nameMother?: string;
  nameMother2?: string;
  civilUnionDate?: DateTime | null;
  martitalStatusDeclarant1?: string;
  martitalStatusDeclarant2?: string;
  civilUnionMunicipality?: string;
  surnameMother?: string;
  surnameMother2?: string;
  residenceMunicipalityDeclarant1?: string;
  residenceMunicipalityDeclarant2?: string;
  surnamePostUnionDeclarant1?: string;
  surnamePostUnionDeclarant2?: string;
  citizenshipDeclarant1?: string;
  citizenshipDeclarant2?: string;
}
export interface DocumentCitizenshipFormVM extends CommonCivilStatusFormVM {
  matricola?: string;
  surname?: string;
  name?: string;
  gender?: string;
  municipalityBirth?: string;
  surnameFather?: string;
  nameFather?: string;
  surnameMother?: string;
  residenceMunicipality?: string;
  citizenshipDate?: DateTime | null;
  nameMother?: string;
  time?: DateTime | null;
  birthday?: DateTime | null;
  birthdayMunicipality?: string;
}
